import { render, staticRenderFns } from "./ButtonComponent.vue?vue&type=template&id=37112b2a&"
import script from "./ButtonComponent.vue?vue&type=script&lang=ts&"
export * from "./ButtonComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37112b2a')) {
      api.createRecord('37112b2a', component.options)
    } else {
      api.reload('37112b2a', component.options)
    }
    module.hot.accept("./ButtonComponent.vue?vue&type=template&id=37112b2a&", function () {
      api.rerender('37112b2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ButtonComponent.vue"
export default component.exports